import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { Hooks, Platform, Util } from "@xt/xtbase";
import styles from "./ConvertBuy/index.module.less";

const { useTranslation } = Hooks;
const { getUrl } = Util;

const BackArrowSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path
      d="M12.5 15L7.5 10L12.5 5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// const ICON_HELP = require("./assets/help-1c.svg").default;
const ICON_HISTORY = require("./assets/history-1c.svg").default;

function CandlestickIcon({ active = false }) {
  const fill = active ? "#b9f78a" : "#eaecef";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" aria-hidden="true">
      <path
        fill={fill}
        d="M4.084 12.583h3.499V7.417h-3.5zm5 .334c0 .644-.523 1.167-1.167 1.167H3.75a1.167 1.167 0 0 1-1.167-1.167V7.083c0-.644.523-1.167 1.167-1.167h4.167c.644 0 1.167.523 1.167 1.167zm3.333 1.333h3.5v-8.5h-3.5zm5 .333c0 .645-.523 1.167-1.167 1.167h-4.167a1.167 1.167 0 0 1-1.167-1.167V5.417c0-.645.523-1.167 1.167-1.167h4.167c.644 0 1.167.522 1.167 1.167z"
      />
      <path
        fill={fill}
        d="M5.083 6.667v-2.5a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0m0 9.166v-2.5a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0m8.334 1.667V15a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0m0-12.5V2.5a.75.75 0 0 1 1.5 0V5a.75.75 0 0 1-1.5 0"
      />
    </svg>
  );
}

/**
 * Figma basicNavigationBar 13999:65213：表单上方 Buy/Sell + 右侧三图标
 */
export default function ConvertBuySellBar({ chartOpen = false, onCandlestickClick, embedded = false }) {
  const t = useTranslation();
  const router = useRouter();
  const isInApp = Platform.isInApp();

  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.push("/");
    }
  };

  return (
    <div className={`${styles["convert-buy__subnav"]} ${embedded ? styles["convert-buy__subnav--embedded"] : ""}`}>
      <div className={styles["convert-buy__subnav-left"]}>
        {!embedded && !isInApp ? (
          <button
            type="button"
            className={styles["convert-buy__subnav-back"]}
            onClick={handleBack}
            aria-label={t("activity.back") || "Back"}
          >
            <BackArrowSvg />
          </button>
        ) : null}
        <h2 className={styles["convert-buy__subnav-title"]}>{t("convert.buySell")}</h2>
      </div>
      <div className={styles["convert-buy__subnav-actions"]}>
        <button
          type="button"
          className={styles["convert-buy__subnav-icon"]}
          onClick={onCandlestickClick}
          aria-label={t("convert.chart")}
          aria-pressed={chartOpen}
        >
          <CandlestickIcon active={chartOpen} />
        </button>
        {/* <button type="button" className={styles["convert-buy__subnav-icon"]} aria-label={t("convert.help")}>
          <img src={ICON_HELP} alt="" width={20} height={20} draggable={false} />
        </button> */}
        <Link
          href={getUrl("/convert/history")}
          className={styles["convert-buy__subnav-icon"]}
          aria-label={t("convert.transactionHistory")}
        >
          <img src={ICON_HISTORY} alt="" width={20} height={20} draggable={false} />
        </Link>
      </div>
    </div>
  );
}
